import { CHART_COLORS_1, MONTHS } from "lib/constants";
import { getClinicShortCode } from "./string-utils";

export const formatOccupancyGraphData = (
  rawData: AllClinicOccupancyEntry[]
): ReportData1[] => {
  const reportData: ReportData1[] = [];

  rawData.forEach((clinicEntry) => {
    const entries = Object.entries(clinicEntry);

    if (entries.length === 0) return; // skip empty entries

    const [clinicName, data] = entries[0];

    if (!clinicName || !data) return; // skip malformed

    const shortCode = getClinicShortCode(clinicName);

    const monthMap = new Map(data.map((entry) => [entry.month, entry]));

    const months: string[] = [...MONTHS];
    const occupied: number[] = [];
    const available: number[] = [];

    MONTHS.forEach((month) => {
      const entry = monthMap.get(month);

      if (entry) {
        const safeTotal = Math.max(entry.occupied, entry.totalrooms);
        const availableRooms = safeTotal - entry.occupied;

        occupied.push(entry.occupied);
        available.push(availableRooms);
      } else {
        occupied.push(0);
        available.push(0);
      }
    });

    reportData.push({
      name: `${clinicName} - A`,
      group: shortCode,
      color: "green",
      data: available,
      months,
    });

    reportData.push({
      name: `${clinicName} - O`,
      group: shortCode,
      color: "red",
      data: occupied,
      months,
    });
  });

  return reportData;
};

export const formatRetentionGraphData = (
  rawData: PractitionerRetentionEntry[],
  clinicName: string
): ReportData => {
  const activeMap: Record<string, number> = {};
  const totalMap: Record<string, number> = {};

  rawData.forEach((entry) => {
    const monthName = entry.month.trim(); // FIX HERE
    const active = Number(entry.activeSubscriptions);
    const total = Math.max(Number(entry.totalPractitioners), 1); // avoid div-by-zero

    activeMap[monthName] = active;
    totalMap[monthName] = total;
  });

  const months: string[] = MONTHS;
  const retentionRates: number[] = months.map((month) => {
    const active = activeMap[month] ?? 0;
    const total = totalMap[month] ?? 1;
    return Math.round((active / total) * 100);
  });

  return {
    color: CHART_COLORS_1[0],
    data: retentionRates,
    months,
  };
};
